import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import './AdminLogin.css';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = login(username, password);

    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="admin-login-page">
      {/* Overlay mobile - minta buka di desktop */}
      <div className="admin-mobile-overlay">
        <div className="admin-mobile-message">
          <i className="bi bi-display"></i>
          <h3>Admin Login</h3>
          <p>Panel admin tidak bisa digunakan di handphone.</p>
          <p className="mb-0">Harap buka di <strong>desktop</strong> atau layar yang lebih lebar.</p>
        </div>
      </div>

      <Container>
        <div className="login-wrapper">
          <Card className="login-card">
            <Card.Body>
              <div className="text-center mb-4">
                <div className="login-icon">
                  <i className="bi bi-shield-lock"></i>
                </div>
                <h2 className="login-title">Admin Login</h2>
                <p className="login-subtitle">Enter your credentials to access the admin panel</p>
              </div>

              {error && (
                <Alert variant="danger" dismissible onClose={() => setError('')}>
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <i className="bi bi-person me-2"></i>
                    Username
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    disabled={loading}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>
                    <i className="bi bi-lock me-2"></i>
                    Password
                  </Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 login-btn"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Logging in...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-box-arrow-in-right me-2"></i>
                      Login
                    </>
                  )}
                </Button>
              </Form>

              <div className="text-center mt-4">
                <a href="/" className="back-home-link">
                  <i className="bi bi-arrow-left me-2"></i>
                  Back to Home
                </a>
              </div>
            </Card.Body>
          </Card>


        </div>
      </Container>
    </div>
  );
}

export default AdminLogin;
